<div class="box-header">
  <div class="d-flex d-component-header">
    <h1 class="header1">رمز کارت مبدا</h1>
    <!-- <span class="bank-name">{{selectedCard.title}}</span> -->
  </div>
</div>
<div class="box-body">
  <!-- card detail -->
  <p style="text-align: right;">
    برای {{actionName}}، از کارت <span class="redSpan">{{selectedCard.title}}</span><span
      class="redSpan" style="display: inline-block; font-family: 'novin_number';"> -
      {{selectedCard.pan}}</span>، رمز دوم و CVV2 کارت بانکی را وارد کنید.
  </p>

  <!-- card expire date -->
  <div class="card-expdate change-date">
    <span> تاریخ انقضای کارت: </span>
    <span style="font-family: 'novin_number'!important; margin-right: 3px;">{{expireDateValue}}</span>
    <button class="btn lightPurpleBtn" (click)="triggerWaitingPaymentFlag()" [routerLink]="'/cards/newCard/edit'"
      [queryParams]="{enable: 'false'}" style="height: 30px;width: 110px!important; margin-right: 10px;"> به‌روز
      رسانی تاریخ</button>
  </div>
  <span class="error-msg" *ngIf="expiredDate">تاریخ انقضای وارد شده‌ی این کارت منقضی شده است.</span>

<!-- get password form -->
  <form [formGroup]="sourceCardPassForm" autocomplete="off">
    <div class="dynamic_pass">
      <div class="form-group">
        <input type="tel" name="passwordasdas" formControlName="sourcePass" autocomplete="new-password" maxlength="15"
          autocomplete="off" class="form-control password" required [(ngModel)]="passObj.pass"
          [class.form-error]="sourceCardPassFormErrors.sourcePass.required || sourceCardPassFormErrors.sourcePass.minlength">
        <span class="floating-label">رمز دوم کارت</span>
        <span class="star">*</span>
        <span *ngIf="sourceCardPassFormErrors.sourcePass.required" class="errorInput">لطفا رمز دوم کارت خود را وارد
          کنید.</span>
        <span *ngIf="sourceCardPassFormErrors.sourcePass.minlength" class="errorInput">لطفا رمز صحیح کارت خود را وارد
          کنید.</span>
      </div>
      <button type="button" [class.spinner]="pooyaLoading" class="btn purpleBtn btn-auto dynamic_pass_btn"
        [disabled]="disabledResend" (click)="getDynamicPass()">{{pooyaButtonText}}
      </button>
    </div>
    <div class="form-group">
      <input class="form-control password" formControlName="cvv2" autocomplete="off" name="cvv2"
        [(ngModel)]="passObj.cvv2" maxlength="15"
        [class.form-error]="sourceCardPassFormErrors.cvv2.required || sourceCardPassFormErrors.cvv2.minlength"
        type="tel" required>
      <span class="floating-label">CVV2</span>
      <span class="star">*</span>
      <span *ngIf="sourceCardPassFormErrors.cvv2.required" class="errorInput">لطفا CVV2 کارت خود را وارد کنید.</span>
      <span *ngIf="sourceCardPassFormErrors.cvv2.minlength" class="errorInput">لطفا CVV2 صحیح کارت خود را وارد
        کنید.</span>
    </div>
    <div class="btnContainer">
      <button class="btn purpleBtn btn-auto" [class.spinner]="isLoading" [disabled]="isLoading" (click)="submitedPass()"
        [disabled]="sourceCardPassForm.invalid">{{buttonTitle}}</button>
      <button (click)="returnAction()" class="btn return-btn btn-auto">بازگشت</button>
    </div>
  </form>
</div>